<template>
    <div class="section-runtime">
        <div class="section-runtime__main">
            <div class="section-runtime__main-map">
                <section-map />
                <div class="section-runtime__progress">Мир завоеван на {{ progress }}%</div>
            </div>
            <div class="section-runtime__main-hints">
                <block-hints class="section-runtime__main-hints--desktop" />
                <span class="section-runtime__main-hints--mobile" @click="openLegend">
                    <img src="@/assets/icons/info.svg" />
                </span>
            </div>
        </div>
        <div class="section-runtime__aside" :class="{'is-open': openAside}">
            <img class="section-runtime__aside-toggle" src="@/assets/icons/arrow-toggle.svg" @click="asideToggle" />

            <div class="section-runtime__balance">
                <block-balance :value="balance" />
            </div>
            <div class="section-runtime__regions">
                <section-regions @open-upgrade="onOpenUpgrade" @close-upgrade-silence="onCloseUpgradeSilence" />
            </div>
        </div>

        <ui-popup ref="legend">
            <div class="section-runtime-legend">
                <block-hints />
            </div>
        </ui-popup>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {},
        data () {
            return {
                openAside: false
            }
        },
        computed: {
            ...mapState('balance', ['balance']),
            ...mapState('progress', ['progress']),
            isAndroid () {
                const ua = navigator.userAgent.toLowerCase()
                return ua.indexOf('android') > -1
            }
        },
        methods: {
            ...mapActions('control', ['pause', 'start']),
            openLegend () {
                this.$refs.legend.open()
            },
            onOpenUpgrade () {
                if (window.innerWidth < 770) {
                    this.openAside = true
                    this.pause()
                }
            },
            onCloseUpgradeSilence () {
                this.openAside = false
            },
            asideToggle () {
                this.openAside = !this.openAside
                if (this.openAside) {
                    this.pause()
                } else {
                    this.start()
                }
            }
        },
        mounted () {
            if (this.isAndroid) {
                document.body.style.overflow = 'hidden'
                document.body.style.height = window.innerHeight + 'px'
                setTimeout(() => {
                    document.scrollingElement.scrollTop = 80
                }, 100)
            }
        },
        beforeDestroy () {
            if (this.isAndroid) {
                document.body.style.overflow = null
                document.body.style.height = null
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-runtime {
        position relative

        &__main {
            margin-right 39rem
            display flex
            flex-direction column
            position relative
            +layout-sm() {
                margin-right 0
                height 35rem
            }
            +layout-xs() {
                margin-right 0
                height 25rem
            }

            &-map {
                position relative
                margin-top 3.7rem
                +layout-sm() {
                    margin 4rem auto 0
                    max-width 550px
                    position static
                }
                +layout-xs() {
                    max-width 350px
                }
                +layout-xxs() {
                    margin 4rem auto 0
                }
            }

            &-hints {
                margin-top 4.7rem
                margin-bottom 2rem
                +layout-sm() {
                    margin-top 0
                    margin-bottom 0
                }

                &--desktop {
                    +layout-sm() {
                        display none
                    }
                }

                &--mobile {
                    display none
                    +layout-sm() {
                        position absolute
                        bottom 1.4rem
                        left 3rem
                        display block
                        z-index 20
                        width 3.1rem
                        height 3.1rem
                        border 0
                        background-color $color-accent
                        border-radius 50%
                        font-size 0
                        padding 0
                        outline none
                        &-icon {
                            display flex
                        }
                    }

                    +layout-xs() {
                        left 2rem
                    }
                }
            }
        }
        &__aside {
            position absolute
            z-index 20
            top -5.6rem
            right 0
            bottom 0
            width 39rem
            display flex
            flex-direction column
            will-change top
            transition top 0.6s ease

            +layout-sm() {
                width 100%
                left 0
                bottom 0
                top 35rem
                margin-right 0
                &.is-open {
                    top 0
                }
            }

            +layout-xs() {
                top 25rem
            }

            &-toggle {
                display none
                position absolute
                top 1rem
                right 1.7rem
                z-index 2
                transform translate(0, -90%)
                transition transform 0.6s ease
                +layout-sm() {
                    display block
                    right 1rem
                }
                +layout-xs() {
                    top 1rem
                    right 1rem
                }
                .is-open & {
                    transform translate(0, 0) rotate(180deg)
                }
            }
        }

        &__regions {
            flex 1 1
            overflow hidden
            +layout-sm() {
                height 100%
            }
        }

        &__progress {
            font-weight $font-bold
            position absolute
            bottom -3.5rem
            left 6rem
            font-size 1.5rem
            z-index 2
            @media(max-width: 900px) {
                left 2rem
            }
            +layout-sm() {
                left auto
                right 2.5rem
                bottom 2rem
            }
        }

        &__balance {
            +layout-sm() {
                display none
            }
        }
    }

    .section-runtime-legend {
        width 45rem
        +layout-xs() {
            width 32rem
        }
        +layout-xxs() {
            width 23.4rem
        }
    }
</style>
